<div class="col-sm-12">

  <h3 class="text-light-blue">
    Meses relacionados ao filtro de <b>{{ this.periodoInicial | date:'dd/MM/yyyy' }}</b> até <b>{{ this.periodoFinal | date:'dd/MM/yyyy' }}</b>
    
    <button class="btn btn-sm btn-danger pull-right" (click)="generateReport()"><i class="fa fa-fw fa-file-pdf-o"></i> Gerar relatório</button>
  </h3>

  <hr>

  <div *ngIf="!loading">
    <div class="spinner"></div>
    <p class="text-center" style="color: #777;margin: -70px 0 100px;">Carregando solicitação, por favor aguarde ...
    </p>
  </div>

  <div *ngIf="loading">

    <div class="col-sm-12 no-padding" *ngIf="relacaoPagamento.length == 0">
      <h4 class="text-muted">Nenhum registro encontrado.</h4>
    </div>

    <div class="col-xs-12 no-padding" *ngIf="relacaoPagamento.length > 0">
      <table class="table table-striped">
        <tbody>
          <tr>
            <th>Favorecido</th>
            <th class="text-center">CPF ou CNPJ</th>
            <th>Natureza da despesa</th>
            <th class="text-center">Data fato</th>
            <th class="text-center">Valor</th>
          </tr>
          <tr *ngFor="let item of relacaoPagamento">
            <td>{{ item.infoextrato }}</td>
            <td class="text-center">{{ formataCpfCnpj(item.despesaId?.cpfCnpjVencedor) }}</td>
            <td>{{ item.tipoDespesaReceita.descricao }}</td>
            <td class="text-center">{{ item.dataFatoMovimentacao | date: 'dd/MM/yyyy' }}</td>
            <td class="text-center"><b style="color: #00a65a">{{ item.valorOp | currency: 'BRL':'symbol-narrow':'1.2-2' }}</b></td>
          </tr>
          <tr>
            <th colspan="4">Total:</th>
            <th class="text-center"><b>{{ total | currency: 'BRL':'symbol-narrow':'1.2-2' }}</b></th>
          </tr>
        </tbody>
      </table>

    </div>

  </div>
</div>